import { call, put } from 'redux-saga/effects';
import api from '@/services/api';
import LoaderActions from '@/store/ducks/loader';
import SkillsActions, { SkillsTypes } from '@/store/ducks/skills';
import { GLOBAL_CONSTANTS } from '@/utils/globalConstants';
import { getAPIErrorPayload } from '@/utils/commonFunctions';

export function* getSkillsRequest() {
  try {
    const {
      API_URLS: { skills },
    } = GLOBAL_CONSTANTS;
    const { data } = yield call(api.get, skills);
    yield put(SkillsActions.getSkillsSuccess(data?.data ?? []));
    yield put(LoaderActions.stopLoaderSuccess());
  } catch (error) {
    yield put(SkillsActions.getSkillsFailure(getAPIErrorPayload(SkillsTypes.GET_SKILLS_REQUEST, error)));
    yield put(LoaderActions.stopLoaderSuccess());
  }
}
